var k = (r) => {
  throw TypeError(r);
};
var D = (r, t, e) => t.has(r) || k("Cannot " + e);
var i = (r, t, e) => (D(r, t, "read from private field"), e ? e.call(r) : t.get(r)), l = (r, t, e) => t.has(r) ? k("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(r) : t.set(r, e), d = (r, t, e, s) => (D(r, t, "write to private field"), s ? s.call(r, e) : t.set(r, e), e), f = (r, t, e) => (D(r, t, "access private method"), e);
import { replaceData as P, noop as K, resolveEnabled as G, skipToken as Q, timeUntilStale as T, ensureQueryFn as x } from "./contact-channels71.js";
import { notifyManager as H } from "./contact-channels70.js";
import { createRetryer as N, isCancelledError as U, canFetch as V } from "./contact-channels109.js";
import { Removable as _ } from "./contact-channels119.js";
var b, S, h, v, n, q, m, u, y, O, X = (O = class extends _ {
  constructor(t) {
    super();
    l(this, u);
    l(this, b);
    l(this, S);
    l(this, h);
    l(this, v);
    l(this, n);
    l(this, q);
    l(this, m);
    d(this, m, !1), d(this, q, t.defaultOptions), this.setOptions(t.options), this.observers = [], d(this, v, t.client), d(this, h, i(this, v).getQueryCache()), this.queryKey = t.queryKey, this.queryHash = t.queryHash, d(this, b, j(this.options)), this.state = t.state ?? i(this, b), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var t;
    return (t = i(this, n)) == null ? void 0 : t.promise;
  }
  setOptions(t) {
    this.options = { ...i(this, q), ...t }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && i(this, h).remove(this);
  }
  setData(t, e) {
    const s = P(this.state.data, t, this.options);
    return f(this, u, y).call(this, {
      data: s,
      type: "success",
      dataUpdatedAt: e == null ? void 0 : e.updatedAt,
      manual: e == null ? void 0 : e.manual
    }), s;
  }
  setState(t, e) {
    f(this, u, y).call(this, { type: "setState", state: t, setStateOptions: e });
  }
  cancel(t) {
    var s, c;
    const e = (s = i(this, n)) == null ? void 0 : s.promise;
    return (c = i(this, n)) == null || c.cancel(t), e ? e.then(K).catch(K) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(i(this, b));
  }
  isActive() {
    return this.observers.some(
      (t) => G(t.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === Q || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !T(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var e;
    const t = this.observers.find((s) => s.shouldFetchOnWindowFocus());
    t == null || t.refetch({ cancelRefetch: !1 }), (e = i(this, n)) == null || e.continue();
  }
  onOnline() {
    var e;
    const t = this.observers.find((s) => s.shouldFetchOnReconnect());
    t == null || t.refetch({ cancelRefetch: !1 }), (e = i(this, n)) == null || e.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), i(this, h).notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((e) => e !== t), this.observers.length || (i(this, n) && (i(this, m) ? i(this, n).cancel({ revert: !0 }) : i(this, n).cancelRetry()), this.scheduleGc()), i(this, h).notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || f(this, u, y).call(this, { type: "invalidate" });
  }
  fetch(t, e) {
    var R, w, E;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (e != null && e.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (i(this, n))
        return i(this, n).continueRetry(), i(this, n).promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const a = this.observers.find((o) => o.options.queryFn);
      a && this.setOptions(a.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const s = new AbortController(), c = (a) => {
      Object.defineProperty(a, "signal", {
        enumerable: !0,
        get: () => (d(this, m, !0), s.signal)
      });
    }, I = () => {
      const a = x(this.options, e), o = {
        client: i(this, v),
        queryKey: this.queryKey,
        meta: this.meta
      };
      return c(o), d(this, m, !1), this.options.persister ? this.options.persister(
        a,
        o,
        this
      ) : a(o);
    }, p = {
      fetchOptions: e,
      options: this.options,
      queryKey: this.queryKey,
      client: i(this, v),
      state: this.state,
      fetchFn: I
    };
    c(p), (R = this.options.behavior) == null || R.onFetch(
      p,
      this
    ), d(this, S, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((w = p.fetchOptions) == null ? void 0 : w.meta)) && f(this, u, y).call(this, { type: "fetch", meta: (E = p.fetchOptions) == null ? void 0 : E.meta });
    const A = (a) => {
      var o, C, F, g;
      U(a) && a.silent || f(this, u, y).call(this, {
        type: "error",
        error: a
      }), U(a) || ((C = (o = i(this, h).config).onError) == null || C.call(
        o,
        a,
        this
      ), (g = (F = i(this, h).config).onSettled) == null || g.call(
        F,
        this.state.data,
        a,
        this
      )), this.scheduleGc();
    };
    return d(this, n, N({
      initialPromise: e == null ? void 0 : e.initialPromise,
      fn: p.fetchFn,
      abort: s.abort.bind(s),
      onSuccess: (a) => {
        var o, C, F, g;
        if (a === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), A(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(a);
        } catch (M) {
          A(M);
          return;
        }
        (C = (o = i(this, h).config).onSuccess) == null || C.call(o, a, this), (g = (F = i(this, h).config).onSettled) == null || g.call(
          F,
          a,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: A,
      onFail: (a, o) => {
        f(this, u, y).call(this, { type: "failed", failureCount: a, error: o });
      },
      onPause: () => {
        f(this, u, y).call(this, { type: "pause" });
      },
      onContinue: () => {
        f(this, u, y).call(this, { type: "continue" });
      },
      retry: p.options.retry,
      retryDelay: p.options.retryDelay,
      networkMode: p.options.networkMode,
      canRun: () => !0
    })), i(this, n).start();
  }
}, b = new WeakMap(), S = new WeakMap(), h = new WeakMap(), v = new WeakMap(), n = new WeakMap(), q = new WeakMap(), m = new WeakMap(), u = new WeakSet(), y = function(t) {
  const e = (s) => {
    switch (t.type) {
      case "failed":
        return {
          ...s,
          fetchFailureCount: t.failureCount,
          fetchFailureReason: t.error
        };
      case "pause":
        return {
          ...s,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...s,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...s,
          ...$(s.data, this.options),
          fetchMeta: t.meta ?? null
        };
      case "success":
        return {
          ...s,
          data: t.data,
          dataUpdateCount: s.dataUpdateCount + 1,
          dataUpdatedAt: t.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!t.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const c = t.error;
        return U(c) && c.revert && i(this, S) ? { ...i(this, S), fetchStatus: "idle" } : {
          ...s,
          error: c,
          errorUpdateCount: s.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: s.fetchFailureCount + 1,
          fetchFailureReason: c,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...s,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...s,
          ...t.state
        };
    }
  };
  this.state = e(this.state), H.batch(() => {
    this.observers.forEach((s) => {
      s.onQueryUpdate();
    }), i(this, h).notify({ query: this, type: "updated", action: t });
  });
}, O);
function $(r, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: V(t.networkMode) ? "fetching" : "paused",
    ...r === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function j(r) {
  const t = typeof r.initialData == "function" ? r.initialData() : r.initialData, e = t !== void 0, s = e ? typeof r.initialDataUpdatedAt == "function" ? r.initialDataUpdatedAt() : r.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: e ? s ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: e ? "success" : "pending",
    fetchStatus: "idle"
  };
}
export {
  X as Query,
  $ as fetchState
};
//# sourceMappingURL=contact-channels114.js.map
